<template>
    <div class="card">
        <div class="card-body">
            <h4 class="header-title mt-0">{{titles.generalInfo}}</h4>
            <div v-if="countries == null">
                <Loading/>
            </div>
            <form @keyup.enter="onSubmit" class="text-left" v-if="countries != null">
                <h3 class="text-center text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</h3>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.firstName"
                                   :inputKey="'firstName'"
                                   :name="titles.firstNameCommercial"
                                   :validate="$v.commercial.firstName"
                                   @method="getValue"
                            />
                        </div>
                        <div class="col-lg-6">
                            <Input :icon="icons.firstName"
                                   :inputKey="'lastName'"
                                   :name="titles.lastNameCommercial"
                                   :validate="$v.commercial.lastName"
                                   @method="getValue"/>
                        </div>
                    </div>
                </div>
                <div class="px-4" v-if="$route.path.includes('validateUser')">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.password"
                                   :inputKey="'newPassword'"
                                   :name="titles.newpassword"
                                   :type="'password'"
                                   :validate="$v.commercial.newPassword"
                                   @method="getValue"/>
                        </div>
                        <div class="col-lg-6">
                            <Input :icon="icons.password"
                                   :inputKey="'newRetypedPassword'"
                                   :name="titles.newRetypedPassword"
                                   :type="'password'"
                                   :validate="$v.commercial.newRetypedPassword"
                                   @method="getValue"
                            />
                        </div>
                    </div>
                </div>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <Input :icon="icons.email"
                                   :inputKey="'email'"
                                   :name="titles.adresseEmailCommercial"
                                   :validate="$v.commercial.email"
                                   @method="getValue"
                            />
                            <div :class="{ 'invalid-feedback-erreur': error == 'UserExist'}"
                                 class="invalid-feedback">
                                {{titles.emailExist}}
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group row">
                                <label class="col-form-label text-left"
                                       for="phone"
                                       style="float:left"
                                       title="Numéro de téléphone"
                                       v-b-tooltip.hover.left
                                ></label>
                                <div class="col-sm-11">
                                    <VuePhoneNumberInput :border-radius="0"
                                                         :countries-height="20"
                                                         :default-country-code="commercial.country.code?commercial.country.code:'FR'"
                                                         :ignored-countries="['IL']"
                                                         :required="true"
                                                         :show-code-on-list="true"
                                                         :translations="translation"
                                                         @input="phoneClicked"
                                                         color="#94878B"
                                                         id="phone"
                                                         ref="PhoneNumberInput"
                                                         size="sm"
                                                         v-model="commercial.phone"/>

                                    <br>
                                    <div :class="{ 'invalid-feedback-erreur': $v.commercial.phone
             && $v.commercial.phone.required == false
              && $v.commercial.phone.$dirty == true
               && $v.commercial.phone.$error == true && phoneIsValid}"
                                         class="invalid-feedback">
                                        {{titles.fieldIsRequired}}
                                    </div>
                                    <div :class="{ 'invalid-feedback-erreur': !phoneIsValid}"
                                         class="invalid-feedback">
                                        Le numéro de téléphone n'est pas valide
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <DropDownVue
                                    :items="countries"
                                    :label="titles.placeholderPays"
                                    :validate="$v.commercial.country.id"
                                    @method="handleChangeDropDown"
                                    icon="fas fa-city"
                                    inputKey="country"
                                    itemKey="id"
                                    itemValue="name"/>
                        </div>
                        <div class="col-lg-6">
                            <Input :icon="icons.society"
                                   :inputKey="'society'"
                                   :name="titles.societyNameCommercial"
                                   :validate="$v.commercial.society"
                                   @method="getValue"/>
                        </div>
                    </div>
                </div>
                <div class="px-4" v-if="role != undefined && !$route.path.includes('validateUser')">
                    <div class="row">
                        <div class="col-lg-6">
                            <DropDownVue :items="status"
                                         :label="titles.statusCommercial"
                                         :simpleSelect="true"
                                         :validate="$v.commercial.status"
                                         @method="handleChangeDropDown"
                                         icon="fas fa-street-view"
                                         inputKey="status"
                                         itemKey="value"
                                         itemValue="name"
                            />
                        </div>
                    </div>
                </div>

                <div class="px-4 text-right">
                    <button
                            :disabled="isLoading"
                            @click="onSubmit"
                            class="btn btn-standard-gradient px-5"
                            type="button"
                    >
                        <b-spinner label="Spinning" small v-if="isLoading"></b-spinner>
                        {{name_btn}}
                    </button>
                    <modal-success
                            :primary-message="titles.confirmationMail"
                            :title="titles.addCommercialMessage"
                            @messageFromModal="closeModal"
                            id="success"
                    />
                    <modal-success
                            :title="titles.updateCommercialMessage"
                            @messageFromModal="closeModal"
                            id="success-edit-commercial"
                    />
                    <modal-success
                            :title="titles.successProfilMessage"
                            @messageFromModal="closeModal"
                            id="success-profile"

                    />
                    <modal-password
                            :title="titles.pleaseTapYourPassword"
                            @messageFromModalPassword="getMessageFromModalPassword"
                            id="tap-password"
                    />
                    <modal-error
                            :title="titles.cannotAddOperationMessage"
                            id="cannot-add-operation"
                    />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import ModalPassword from '../../common/modal-password';
    import {
        email,
        helpers,
        minLength,
        required,
        sameAs
    } from 'vuelidate/lib/validators';
    import {
        addCommercial,
        updateCommercial
    } from '@/components/shared/services/user.service';
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import ModalSuccess from '@/components/common/modal-success';
    import {titles} from '../../../utils/general/titles.js';
    import {country} from '../models/country';
    import {
        updateUser,
        validateUser
    } from '../services/user.service';
    import {getAllCountriesJson} from '../services/country.service';
    import DropDownVue from '../../common/DropDownVue';
    import {icons} from '../../../utils/general/icons';
    import Input from '@/components/common/Input.vue';
    import {commercial} from '../models/commercial';
    import ModalError from '../../common/modal-error';
    import {DEFAULT_COUNTRY_CODE} from '../../../config/config';
    import Loading from '../../common/Loading';
    import {errorMixin} from '../../../utils/errorMixin';

    const mustBeValidPassword = helpers.regex(
        'alpha',
        /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/
    );
    export default {
        name: 'commercial-form',
        components: {Loading, VuePhoneNumberInput, Input, ModalSuccess, DropDownVue, ModalPassword, ModalError},
        props: {
            form: Object
        },
        data() {
            return {
                titles,
                icons,
                countries: null,
                translation: {
                    countrySelectorLabel: '',
                    countrySelectorError: '',
                    phoneNumberLabel: titles.phone,
                    example: titles.examplePhoneNumber
                },
                isLoading: false,
                isEditable: false,
                errorMsg: '',
                name_btn: this.$route.path.includes('profile') ? titles.update :
                    this.$route.path.includes('validateUser') ? titles.activateCompte : titles.add,
                title: titles.commercialAddExpression,
                status: [
                    {
                        id: 1,
                        name: 'Actif',
                        value: true
                    },
                    {
                        id: 2,
                        name: 'Inactif',
                        value: false
                    }
                ],
                statusObject: null,
                commercial: this.form,
                isItems: true,
                msgModal: null,
                msgModalSucess: null,
                phoneIsValid: true,
                error: null,
                role: null
            };
        },
        validations() {
            if (this.$route.path.includes('validateUser') && this.$route.params.state == 0) {
                return {
                    commercial: {
                        firstName: {required},
                        lastName: {required},
                        email: {required, email},
                        newPassword: {required, mustBeValidPassword, minLength: minLength(6)},
                        newRetypedPassword: {required, sameAsPassword: sameAs('newPassword')},
                        society: {required},
                        country: {
                            required,
                            id: {required}
                        },
                        phone: {required}

                    }
                };
            } else {
                return {
                    commercial: {
                        firstName: {required},
                        lastName: {required},
                        email: {required, email},
                        status: {required},
                        society: {required},
                        country: {
                            required,
                            id: {required}
                        },
                        phone: {required}
                    }
                };
            }
        },
        created() {
            getAllCountriesJson().then(response => {
                this.countries = response.data.map(item => country(item));
                this.countries = this.countries.filter(item => item.code != DEFAULT_COUNTRY_CODE);
            });
            if (this.$cookies.isKey('user')) {
                this.role = this.$cookies.get('user').roles.find(item => item === 'ROLE_ADMIN');
            }
            if (this.$route.path.includes('add')) {
                this.$cookies.remove('commercialItem');
                this.$cookies.remove('commercialItemIsEditable');
            }
            if (this.$route.params.commercialItem) {
                this.$cookies.set('commercialItem', this.$route.params.commercialItem);
                this.$cookies.set('commercialItemIsEditable', this.$route.params.isEditable);
            }
            if (this.$cookies.isKey('commercialItem')) {
                this.commercial = this.$cookies.get('commercialItem');
                this.isEditable = this.$cookies.get('commercialItemIsEditable');
                this.title = titles.commercialDetailExpression;
                this.name_btn = titles.update;
            }

            this.isItems = false;
        },
        updated() {
            this.commercial.phoneNumberCode = this.$refs.PhoneNumberInput.countryCode;
        },
        mixins: [errorMixin],
        methods: {
            phoneClicked() {
                if (Object.keys(this.$v.commercial.phone.$params).length != 0
                    && this.$refs.PhoneNumberInput.isValid != true && this.commercial.phone != null) {
                    this.phoneIsValid = false;
                } else {
                    this.phoneIsValid = true;
                }
                if (!this.$refs.PhoneNumberInput.hasEmptyPhone) {
                    this.$v.commercial.phone.$touch();
                }
            },
            getMessageFromModalPassword(msgModal) {
                this.msgModal = msgModal;
                if (this.msgModal != null && typeof this.msgModal === 'string') {
                    this.updateProfile();
                } else if (typeof this.msgModal === 'boolean') {
                    this.isLoading = false;
                }
            },
            updateProfile() {
                updateUser(this.commercial, this.$store.getters.user.id).then(
                    response => {
                        if (this.commercial.firstName != this.$cookies.get('user').firstName) {
                            this.$store.getters.user.firstName = this.commercial.firstName;
                        }
                        this.$bvModal.show('success-profile');
                        this.isLoading = false;
                        return response;
                    },
                    error => {
                        this.showError(error);
                    }
                );
            },
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid || !this.phoneIsValid) {
                    return;
                }
                this.errorMsg = null;
                this.isLoading = true;
                this.commercial.status = this.commercial.status === true;
                if (this.$route.path.includes('profile')) {
                    if (this.commercial.email != this.$cookies.get('user').email) {
                        this.$bvModal.show('tap-password');
                    } else {
                        this.updateProfile();
                    }
                } else if (!this.$route.params.commercialItem && !this.$route.path.includes('validateUser')) {
                    const commercialized = commercial(this.commercial);
                    commercialized.country = commercialized.country.id;
                    delete commercialized.id;
                    delete commercialized.lastLogin;
                    addCommercial(commercialized).then(
                        response => {
                            this.commercial.id = response.data.id;
                            this.$bvModal.show('success');
                            this.isLoading = false;
                        },
                        error => {
                            const err = error.response;
                            switch (err.status) {
                                case 403:
                                    this.errorMsg = err.data.detail;
                                    break;
                                case 400:
                                    if (err.data.error === 'UserExist') {
                                        this.error = err.data.error;
                                    } else if (err.data.error === 'haveMustCharacters') {
                                        this.errorMsg = err.data.message;
                                    } else if (error.response.data.message === 'Form Invalid') {
                                        this.$bvModal.show('cannot-add-operation');
                                        this.isLoading = false;
                                    }
                                    break;
                                default:
                                    this.errorMsg = 'Une erreur inconnue est survenue. Réessayez plus tard.';
                            }
                            this.isLoading = false;
                        }
                    );
                } else if (this.$route.path.includes('validateUser')) {
                    validateUser(this.commercial).then(
                        response => {
                            this.$store.dispatch('handle', response);
                            this.isLoading = false;
                        },
                        error => {
                            this.showError400(error);
                        }
                    );
                } else {
                    updateCommercial(this.commercial, this.commercial.id).then(
                        response => {
                            this.commercial.id = response.data.id;
                            this.$emit('getCommercial', this.commercial);
                            this.$bvModal.show('success-edit-commercial');
                            this.isLoading = false;
                            return response;
                        },
                        error => {
                            const err = error.response;
                            this.error = err.data['hydra:description'];
                            this.showError400(error);
                        }
                    );
                }
            },
            getValue(inputKey, val) {
                this.error = null;
                if (this.$v.commercial[inputKey]) {
                    this.$v.commercial[inputKey].$touch();
                }
                this.commercial[inputKey] = val;
            },
            handleChangeDropDown(val, inputKey) {
                this.commercial[inputKey] = val;
            },
            closeModal(modal) {

                if (this.$route.path.includes('profile')) {
                    this.msgModalSucess = modal;
                    if (typeof this.msgModal === 'string' && this.msgModalSucess === true) {
                        this.$router.push({name: 'login'});
                    }
                } else {
                    if (this.$cookies.isKey('commercialItem') != false) {
                        this.$cookies.remove('commercialItem');
                        this.$cookies.remove('commercialItemIsEditable');
                    }
                    this.$router.push({name: 'listCommercial'});
                }
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/vue-phone-number-input.css';
</style>
